// The Workspace Me is narrowed to, per window (its id; null: not narrowed).
// It is not in the URL: Me is only ever opened by its owner, so a link with it
// means nothing to anyone else.
//
// Promise: every list of Me reads the same value (`useMeWorkspace`); it
// survives moving between screens of the window and is gone on reload.
// Opening Me with router state `{ workspace }` (cloud's "my things" row of a
// Workspace) sets it.
import { useSyncExternalStore } from "react";
import { useMeApp } from "./context";

export interface WorkspaceFilter {
  get(): string | null;
  set(workspace: string | null): void;
  subscribe(onChange: () => void): () => void;
}

export function createWorkspaceFilter(): WorkspaceFilter {
  let value: string | null = null;
  const subs = new Set<() => void>();
  return {
    get: () => value,
    set(workspace) {
      if (workspace === value) return;
      value = workspace;
      for (const fn of subs) fn();
    },
    subscribe(fn) {
      subs.add(fn);
      return () => subs.delete(fn);
    },
  };
}

export function useMeWorkspace(): [
  string | null,
  (workspace: string | null) => void,
] {
  const { workspaceFilter } = useMeApp();
  const value = useSyncExternalStore(
    workspaceFilter.subscribe,
    workspaceFilter.get,
    workspaceFilter.get,
  );
  return [value, workspaceFilter.set];
}
